export default __webpack_public_path__ + "static/media/landscape2-MASK-zahner2.5ed9db26.png";